module.exports = __webpack_public_path__ + "ne.13e02dc6.svg";